import React, { createRef, useEffect, useState } from "react";
import styled from "styled-components";
import { AlertBox } from "../AlertBox";
import { Box } from "../Box";
import { Icon } from "../Icon";
/**
 * Event declaration
 */
export var Level;
(function (Level) {
    Level["success"] = "success";
    Level["info"] = "info";
    Level["warning"] = "warning";
    Level["error"] = "error";
})(Level || (Level = {}));
const NOTIFY = "notify";
/**
 * Event communication
 */
export const notify = (message, level = Level.success, options = {}) => document.dispatchEvent(new CustomEvent(NOTIFY, { detail: { level, message, options } }));
const CloseButton = styled.div `
  float: right;
  cursor: pointer;
`;
/**
 * React Views
 */
export const NotificationView = ({ level, message, options }) => {
    const ref = createRef();
    const { sticky, dismissAfter } = options || {};
    const [closed, setClosed] = useState(false);
    const usesClose = !sticky && dismissAfter === undefined;
    // FIXME: move this to animations
    useEffect(() => {
        const self = ref.current;
        if (!self)
            return;
        self.ontransitionend = () => { var _a; return (_a = self.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(self); };
        // dismiss after?
        if (dismissAfter !== undefined)
            setTimeout(() => setClosed(true), dismissAfter);
    }, [dismissAfter, ref]);
    return (React.createElement(Box, { "data-testid": "notification", ref: ref, mt: 2, style: {
            opacity: closed ? 0 : 1,
            transition: "opacity 300ms ease-out",
        } },
        React.createElement(AlertBox, { variant: level },
            message,
            usesClose && (React.createElement(CloseButton, { "data-testid": "close", onClick: () => setClosed(true) },
                React.createElement(Icon, { src: "Close", size: "12px" }))))));
};
export const Notifier = () => {
    const [notifications, setNotifications] = useState([]);
    const processNotification = ({ detail: { message, level, options } }) => setNotifications([...notifications, { level, message, options }]);
    useEffect(() => {
        document.addEventListener(NOTIFY, processNotification);
        return () => {
            document.removeEventListener(NOTIFY, processNotification);
        };
    });
    return (React.createElement(React.Fragment, null, notifications.map((notification, i) => (React.createElement(NotificationView, Object.assign({ key: i }, notification))))));
};
